import { render, staticRenderFns } from "./RadioFlags.vue?vue&type=template&id=1ecc6b29&scoped=true&"
import script from "./RadioFlags.vue?vue&type=script&lang=js&"
export * from "./RadioFlags.vue?vue&type=script&lang=js&"
import style0 from "./RadioFlags.vue?vue&type=style&index=0&id=1ecc6b29&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ecc6b29",
  null
  
)

export default component.exports